import PropTypes from 'prop-types'
import classNames from 'classnames'

import { initialsOf } from '../../utility/helperFunctions'

import classes from './CommunityChip.module.scss'

const CommunityChip = ({ community }) => (
  <span className={classNames(classes.chip, 'd-inline-flex align-items-center')}>
    {community.photo ? (
      <img src={community.photo.small_file_url} alt='' className={classNames(classes.photo, 'flex-shrink-0')} />
    ) : (
      <span className={classNames(classes.photo, classes.initials, 'd-inline-flex align-items-center justify-content-center flex-shrink-0')}>
        {initialsOf(community.name)}
      </span>
    )}
    <span className={classes.name}>{community.name}</span>
  </span>
)

CommunityChip.propTypes = {
  community: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    photo: PropTypes.shape({ small_file_url: PropTypes.string }),
  }).isRequired,
}

export default CommunityChip
